// import { BuildingImg, } from "../assets/images";
// import AuthImages from "../components/AuthImages";

// const ForgotPassword = () => {

//     return (
//         <div className="auth-page">
//             <div className="auth-row d-flex w-100">
//                 <AuthImages />
//                 <div className="auth-login-box">
//                     <div className="auth-form d-flex flex-column justify-content-center mx-auto">
//                         <div className="auth-form-title">
//                             <div className="icon">
//                                 <img src={BuildingImg} alt="Building" />
//                             </div>
//                             <h2>Forgot Your Password?</h2>
//                             <p>No worries! Enter your email address and we'll send you a verification link to reset your password.</p>
//                         </div>
//                         <form>
//                             <div className="form-group">
//                                 <label>E-mail</label>
//                                 <input type="email" className="form-control" placeholder="Enter your email" />
//                             </div>
//                             <button type="submit" className="btns">Continue</button>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ForgotPassword;

import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { BuildingImg } from "../assets/images";
import AuthImages from "../components/AuthImages";

const ForgotPassword = () => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // ✅ Validation schema
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  // ✅ Formik setup
  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setError("");
      setMessage("");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}auth/forgot_password`, // backend endpoint
          values,
          { headers: { "Content-Type": "application/json", "api-key": process.env.REACT_APP_API_KEY } }
        );

        const { status, data } = response;
        if (status === 200 && data?.status === "success") {
          setMessage("Check your email for reset password link.");
          resetForm();
        } else {
          setError(data?.message?.keyword || "Something went wrong.");
        }
      } catch (err) {
        setError(
          err.response?.data?.message?.keyword || "Something went wrong."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="auth-page">
      <div className="auth-row d-flex w-100">
        <AuthImages />
        <div className="auth-login-box">
          <div className="auth-form d-flex flex-column justify-content-center mx-auto">
            <div className="auth-form-title">
              <div className="icon">
                <img src={BuildingImg} alt="Building" />
              </div>
              <h2>Forgot Your Password?</h2>
              <p>
                No worries! Enter your email address and we'll send you a
                verification link to reset your password.
              </p>
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className="form-group">
                <label>E-mail</label>
                <input
                  type="email"
                  name="email"
                  className={`form-control ${
                    formik.touched.email && formik.errors.email
                      ? "is-invalid"
                      : ""
                  }`}
                  placeholder="Enter your email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.email}
                  </div>
                )}
              </div>

              {/* Messages */}
              {error && <p className="text-danger">{error}</p>}
              {message && <p className="text-success">{message}</p>}

              <button
                type="submit"
                className="btns"
                disabled={formik.isSubmitting}
              >
                {formik.isSubmitting ? "Processing..." : "Continue"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;